import { render } from "./PageNotificationError.vue?vue&type=template&id=10aeac9b"
import script from "./PageNotificationError.vue?vue&type=script&lang=js"
export * from "./PageNotificationError.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shanbhad/Documents/BitBucket/storyfinder2_ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__